/**
 * EU / EEA / UK country codes where the subscribe modal shows an extra explicit
 * marketing-consent checkbox (GDPR-style opt-in). Keyed on the viewer's
 * `privateProfile.billingCountryCode`. Ported verbatim from PopshopRN's
 * `kPopStoreCreatorConsentCountryCodes` (`flows/bio/constants.ts`).
 */
export const kCreatorConsentCountryCodes: ReadonlySet<string> = new Set([
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'EL', // Greece (EU convention)
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'IS', // Iceland (EEA)
  'LI', // Liechtenstein (EEA)
  'NO', // Norway (EEA)
  'GB', // United Kingdom
]);
